import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { Chatbot } from "./components/Chatbot";

// Lazy load page components
const HomePage = React.lazy(() => import("./pages/HomePage").then(module => ({ default: module.HomePage })));
const SolutionsPage = React.lazy(() => import("./pages/SolutionsPage").then(module => ({ default: module.SolutionsPage })));
const SolutionDetailPage = React.lazy(() => import("./pages/SolutionDetailPage").then(module => ({ default: module.SolutionDetailPage })));
const WhiteLabelPage = React.lazy(() => import("./pages/WhiteLabelPage").then(module => ({ default: module.WhiteLabelPage })));
const ContactPage = React.lazy(() => import("./pages/ContactPage").then(module => ({ default: module.ContactPage })));
const PricingPage = React.lazy(() => import("./pages/PricingPage").then(module => ({ default: module.PricingPage })));
const TermsPage = React.lazy(() => import("./pages/TermsPage").then(module => ({ default: module.TermsPage })));
const PrivacyPage = React.lazy(() => import("./pages/PrivacyPage").then(module => ({ default: module.PrivacyPage })));
const CookiesPage = React.lazy(() => import("./pages/CookiesPage").then(module => ({ default: module.CookiesPage })));
const BlogPage = React.lazy(() => import("./pages/BlogPage").then(module => ({ default: module.BlogPage })));
const BlogPostPage = React.lazy(() => import("./pages/BlogPostPage").then(module => ({ default: module.BlogPostPage })));
const SitemapPage = React.lazy(() => import("./pages/SitemapPage").then(module => ({ default: module.SitemapPage })));
const NotFoundPage = React.lazy(() => import("./pages/NotFoundPage").then(module => ({ default: module.NotFoundPage })));

// Loading component
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-orange-500"></div>
  </div>
);

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-[#050505] text-white font-sans selection:bg-orange-500/30">
        <Navbar />
        <main>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/solutions" element={<SolutionsPage />} />
              <Route path="/solutions/:id" element={<SolutionDetailPage />} />
              <Route path="/white-label" element={<WhiteLabelPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:id" element={<BlogPostPage />} />
              <Route path="/demo" element={<ContactPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/sitemap" element={<SitemapPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <Chatbot />
      </div>
    </Router>
  );
}
